/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Unprocessable entity
 * @export
 * @interface DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntity
 */
export interface DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntity {
    /**
     * Unprocessable entity message
     * @type {string}
     * @memberof DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntity
     */
    error?: string;
}

/**
 * Check if a given object implements the DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntity interface.
 */
export function instanceOfDeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntity(value: object): value is DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntity {
    return true;
}

export function DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntityFromJSON(json: any): DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntity {
    return DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntityFromJSONTyped(json, false);
}

export function DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntityToJSON(json: any): DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntity {
    return DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntityToJSONTyped(json, false);
}

export function DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntityToJSONTyped(value?: DeleteCharactersCharacterIdMailLabelsLabelIdUnprocessableEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

